import { _get } from "./Axios";

export default class DashboardApi {
  static getData(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
        params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("dashboard?" + params);
  }
  static getKpiPegawai(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
        params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("dashboard/kpi-pegawai?" + params);
  }
}
